module.exports = __webpack_public_path__ + "media/images/sports_icons/026-poker-cards-abfe9130da45ab0b3aca0aaa350359e6.png";